import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



const CreateVirtualOffice = (props) => {

  const listVirtualOffice = (e) => {
    props.setUpdateOrCreate("n")
  }

    const [title, setTitle] = useState();
    const [starttime, setStarttime] = useState(new Date());
    const [endtime, setEndtime] = useState(new Date());
    const [eventType, setEventType] = useState(0);


    const submitForm = () => {

        const body = {
          title: title,
          starttime: starttime.toISOString(),
          endtime: endtime.toISOString(),
          eventtype: eventType
        }
        apiPut(`intranetevents/insertevent`, body)
          .then(response => {if(response.ok){
            response.json().then(result => {
              props.setId(result[0].id)
              props.setUpdateOrCreate("u")
            })
            
          }})
          .catch( err => console.log(err) )

        

      }

      return (
      <Container>
        <Row>
            <Col>
              <h1>Create New Event</h1>
            </Col>
        </Row>
        <Form>
          <div className="section">
            <Row>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.title">
                      <Form.Label>Title</Form.Label>
                      <Form.Control onChange={(event) => setTitle(event.target.value)} type="text" value={title} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.eventtype">
                      <Form.Label>Event type</Form.Label>
                      <Form.Control value={eventType} onChange={(event) => setEventType(Number(event.target.value))} as="select">
                        <option value={0}>Standard event</option>
                        <option value={7}>Speed networking</option>
                      </Form.Control>
                    </Form.Group>
                </Col>
                
            </Row>
            <Row>
            
            <Col md={4}>
                <Form.Group controlId="blogCreate.date">
                      <Form.Label>Start Time</Form.Label>
                      <DatePicker 
                        selected={starttime} 
                        onChange={(date) => setStarttime(date)}
                        showTimeSelect
                        locale="enGB"
                        dateFormat='dd/MM/yyyy HH:mm'
                       />
                    </Form.Group>   
            </Col>
            <Col md={4}>
                    <Form.Group controlId="blogCreate.date">
                      <Form.Label>End Time</Form.Label>
                      <DatePicker 
                        selected={endtime} 
                        onChange={(date) => setEndtime(date)}
                        showTimeSelect
                        locale="enGB"
                        dateFormat='dd/MM/yyyy HH:mm'
                       />
                    </Form.Group> 
            </Col>
            </Row>
            <Row>
                <Button onClick={submitForm} value={title} style={{marginBottom:"30px"}} className="btn btn-primary">
                  Submit
                </Button>
                <Button onClick={(event) => listVirtualOffice(event)} style={{marginBottom:"30px"}}  className="btn btn-primary">
                  Go back
                </Button>
            </Row>
            </div>
        </Form>
      </Container>
      );


    

}

export default CreateVirtualOffice;